import { getMarae } from "./marae";
import { request, ENDPOINTS } from "./api";

export const getTakiwa = async () => {
    const groups = await request.get(ENDPOINTS.groups);
    const marae = await getMarae();

    const getTakiwa = (name) =>
        groups.takiwa.find(({ value }) => value === name).value;

    return [
        {
            description: getTakiwa("Hautapu"),
            id: 633035,
            marae: [
                marae.Raketapauma,
                marae.Kuratahi,
                marae["Te Ao Hou"],
                null,
            ],
        },
        {
            description: getTakiwa("Whangaehu"),
            id: 633034,
            marae: [marae.Tirorangi, marae.Tirohia, marae.Mokai, null],
        },
        {
            description: getTakiwa("Mangawhero"),
            id: 633037,
            marae: [
                marae.Maungarongo,
                marae.Mangamingi,
                marae["Tuhi Ariki"],
                null,
            ],
        },
        {
            description: getTakiwa("Te Waimarino"),
            id: 633036,
            marae: [
                marae.Raetihi,
                marae.Marangai,
                marae.Motekatoa,
                marae.Waitahuparae,
            ],
        },
    ];
};
